import { render } from "./BaseInput.vue?vue&type=template&id=0480144c&scoped=true"
import script from "./BaseInput.js?vue&type=script&lang=js"
export * from "./BaseInput.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0480144c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0480144c"]])

export default __exports__